<template>
  <div>
    <b-modal
      title="更新墊繳"
      size="lg"
      centered
      hide-footer
      header-class="head-modal"
      v-model="modalShow"
    >
      <b-form-group label-cols="4" label-cols-lg="2" label="墊繳行政費" label-for="input-default">
        <b-form-input type="number" v-model="data.behalf_fee"></b-form-input>
      </b-form-group>

      <b-form-group label-cols="4" label-cols-lg="2" label="墊繳欠款" label-for="input-default">
        <b-form-input type="number" v-model="data.behalf_debt"></b-form-input>
      </b-form-group>

      <b-form-group label-cols="4" label-cols-lg="2" label="墊繳還款日" label-for="input-default">
        <date-picker
          v-model="data.behalf_repayment_at"
          :position="'left'"
          placeholder="墊繳還款日"
        ></date-picker>
      </b-form-group>

      <div class="text-center mt-4">
        <b-button
          class="mr-2"
          variant="success"
          size="sm"
          @click="sumit()"
        >
          確定
        </b-button>
        <b-button
          variant="danger"
          size="sm"
          class="mr-4"
          @click="$emit('change', false)"
        >
          取消
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import billApi from "@/models/API/billApi";
import datePicker from '@/components/common/DatePicker';

export default {
  name: 'UpdatePaymentModal',
  components: {
    datePicker
  },
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    data: {
      type: Object,
      required: false,
      default: () => {}
    },
  },
  data () {
    return {

    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
  },
  mounted() {
    this.billApi = new billApi();
  },
  methods: {
    // 匯出未繳費帳單
    sumit() {
      this.$emit('sumit');
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/components/modal/UpdatePaymentModal.vue